import storage from 'local-storage-fallback'
import App from 'modules/App'
import React from 'react'
import { createRoot } from 'react-dom/client'
// JS import (not CSS @import): css-loader @import only uses the `style` export
// and hits dist, which ModuleScopePlugin blocks via the docker kit symlink.
// Webpack `development` → empty stub; prod `default` → dist/gu-ui-kit.css.
import 'gu-ui-kit/gu-ui-kit.css'
import 'global.scss'

if (!('localStorage' in window)) {
  global.localStorage = storage
}

console.logXHR = console.error

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/frontend/react-app/sw.js', {
          scope: '/',
        })
        .catch(() => {})
    })
  }
}

const root = createRoot(document.getElementById('app-root'))
root.render(<App />)
